import { ApiCustomer } from '@vend/types'
import { EMAIL_REGEX } from '../../../../constants'

import { CONTACT_OPTIONS, CustomerInfo } from './types'

export const isInvalidEmail = (customer: CustomerInfo | ApiCustomer | null) => {
  const email = customer && customer.email && customer.email.trim()

  if (email) {
    return !email.match(EMAIL_REGEX)
  }

  return false
}

export const hasContactInfo = (customer: ApiCustomer | CustomerInfo | null) => {
  const contact: string[] = []
  if (customer) {
    Object.values(CONTACT_OPTIONS).forEach((option: CONTACT_OPTIONS) => {
      const value = customer[option]
      if (value && value.trim()) {
        contact.push(option)
      }
    })
  }
  return contact.length > 0
}

export const getDefaultContactOption = (
  customer: CustomerInfo | ApiCustomer | null
) => {
  if (customer) {
    if (customer.mobile) {
      return CONTACT_OPTIONS.MOBILE
    } else if (customer.phone) {
      return CONTACT_OPTIONS.PHONE
    } else if (customer.fax) {
      return CONTACT_OPTIONS.FAX
    }
  }

  return CONTACT_OPTIONS.MOBILE
}

export const trimContactInfo = (customer: ApiCustomer) => {
  Object.values(CONTACT_OPTIONS).forEach(option => {
    const value = customer[option]
    customer[option] = value && value.trim()
  })
}

export const contactUpdated = (
  customer: ApiCustomer | null,
  originalCustomer: ApiCustomer | null
): boolean => {
  if (!customer || !originalCustomer) {
    return false
  }

  const combinedValues = [
    ...Object.values(CONTACT_OPTIONS),
    'customer_group_id',
  ] as Array<keyof ApiCustomer>

  return Object.values(combinedValues).some(option => {
    const value = customer[option] && (customer[option]! as string).trim()
    const preValue =
      originalCustomer[option] && (originalCustomer[option]! as string).trim()
    return value !== preValue
  })
}
